export const UPDATE_DASHBOARD_PART_DATA = 'Dashboard/UPDATE_DASHBOARD_PART_DATA';
export const RESET_DASHBOARD_PART_DATA = 'Dashboard/RESET_DASHBOARD_PART_DATA';

export const updateDashboardPartData = (id, data) => ({
  type: UPDATE_DASHBOARD_PART_DATA,
  payload: { id, data },
});

export const resetDashboardPartData = () => ({
  type: RESET_DASHBOARD_PART_DATA,
});
